import { useMutation, useQueryClient } from '@tanstack/react-query';

import { SubscriberPlanEnum } from '@/interfaces/entities/subscription.';
import { notificationService } from '@/services/notification.service';
import { subscriptionService } from '@/services/subscription.service';

const useUpdateUserSubscription = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			userId,
			status,
		}: {
			userId: number;
			status: SubscriberPlanEnum;
		}) => await subscriptionService.giveSubscription(userId, status),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['user'] });
			notificationService.success('Subscription updated');
		},
		onError: () => {
			notificationService.error('Error updating subscription');
		},
	});
};

export default useUpdateUserSubscription;
